import type { MarketVariants } from '@/lib/i18n'

export type Slide1TitleCopy = {
  eyebrow: string
  title: string
  subtitle: string
  hintDesktop: string
  hintMobile: string
}

export const copy: MarketVariants<Slide1TitleCopy> = {
  US: {
    eyebrow: 'Chapter 3',
    title: 'Your Ultimate Defense',
    subtitle:
      "Last chapter, we saw how scammers use emotion to rush people into fast decisions. Now let's look at a simple habit that puts you back in control.",
    hintDesktop: 'Tip: Arrow keys also work',
    hintMobile: 'Swipe or tap Next',
  },
  // QA: nothing to localize ("Defense" becomes "Defence" at render).
  ar: {
    eyebrow: 'الفصل 3',
    title: 'خط دفاعك الأقوى',
    subtitle:
      'في الفصل السابق رأينا كيف يستغل المحتالون العاطفة لدفع الناس إلى قرارات متسرّعة. والآن لنتعرّف على عادة بسيطة تعيد إليك زمام الأمور.',
    hintDesktop: 'تلميح: يمكنك أيضاً استخدام مفاتيح الأسهم',
    hintMobile: 'اسحب أو اضغط "متابعة"',
  },
}
